import React, { useState, useEffect } from 'react';
import { getTransfers, getRailwayData, getRailwayDataByBureau } from '../services/api';

function Home() {
  const [transfers, setTransfers] = useState([]);
  const [filters, setFilters] = useState({ type: '', bureau: '', unit: '' });
  const [bureauNames, setBureauNames] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadRailwayData();
  }, []);

  useEffect(() => {
    loadTransfers();
  }, [filters]);

  useEffect(() => {
    if (filters.bureau) {
      loadBureauUnits(filters.bureau);
    } else {
      setUnitOptions([]);
    }
  }, [filters.bureau]);

  const loadRailwayData = async () => {
    try {
      const res = await getRailwayData();
      setBureauNames(res.data.bureauNames);
    } catch (err) {
      console.error('加载数据失败', err);
    }
  };

  const loadBureauUnits = async (bureau) => {
    try {
      const res = await getRailwayDataByBureau(bureau);
      setUnitOptions(res.data.allUnits);
    } catch (err) {
      console.error('加载站段数据失败', err);
    }
  };

  const loadTransfers = async () => {
    try {
      const res = await getTransfers(filters);
      setTransfers(res.data.transfers);
    } catch (err) {
      console.error('加载失败', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-xl p-8 mb-8 shadow-xl">
        <h1 className="text-4xl font-bold mb-3">铁路对调平台</h1>
        <p className="text-blue-100 text-lg">全国18个铁路局，专业系统分类筛选</p>
        <p className="text-blue-200 mt-2 font-medium text-xl">duidiao.hongjian.cn</p>
      </div>

      <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          筛选条件
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">对调类型</label>
            <select
              className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
              value={filters.type}
              onChange={(e) => setFilters({ ...filters, type: e.target.value })}
            >
              <option value="">全部</option>
              <option value="对调">对调</option>
              <option value="单调">单调</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">铁路局</label>
            <select
              className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all"
              value={filters.bureau}
              onChange={(e) => setFilters({ ...filters, bureau: e.target.value, unit: '' })}
            >
              <option value="">全部</option>
              {bureauNames.map(b => <option key={b} value={b}>{b}局</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">站段</label>
            <select
              className="w-full border-2 border-gray-200 rounded-lg px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              value={filters.unit}
              onChange={(e) => setFilters({ ...filters, unit: e.target.value })}
              disabled={!filters.bureau}
            >
              <option value="">全部</option>
              {unitOptions.map(u => <option key={u} value={u}>{u}</option>)}
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-16">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <div className="text-gray-500 text-lg">加载中...</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {transfers.map(t => (
            <div key={t.id} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden">
              <div className="bg-gradient-to-r from-blue-50 to-white px-6 py-4 border-b border-gray-100">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className={`px-4 py-1.5 rounded-full text-sm font-bold ${t.type === '对调' ? 'bg-green-500 text-white' : 'bg-blue-500 text-white'}`}>
                      {t.type}
                    </span>
                    <span className="text-gray-500 text-sm">
                      {new Date(t.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <span className="text-gray-600 text-sm font-medium">
                    {t.username}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <div className="grid grid-cols-1 gap-5 mb-4">
                  <div className="bg-blue-50 rounded-lg p-4 border-l-4 border-blue-500">
                    <h3 className="font-bold text-blue-800 mb-2">
                      当前单位
                    </h3>
                    <p className="text-gray-800 font-semibold">{t.current_bureau}局</p>
                    <p className="text-gray-700">{t.current_unit}</p>
                    {t.current_workshop && <p className="text-gray-500 text-sm mt-1"><span className="font-medium">车间:</span> {t.current_workshop}</p>}
                  </div>
                  
                  <div className="bg-red-50 rounded-lg p-4 border-l-4 border-red-500">
                    <h3 className="font-bold text-red-800 mb-2">
                      目标单位
                    </h3>
                    <p className="text-gray-800 font-semibold">{t.target_bureau}局</p>
                    <p className="text-gray-700">{t.target_unit}</p>
                    {t.target_workshop && <p className="text-gray-500 text-sm mt-1"><span className="font-medium">车间:</span> {t.target_workshop}</p>}
                  </div>
                </div>
                
                {t.remark && (
                  <div className="bg-yellow-50 rounded-lg p-4 mb-4 border border-yellow-100">
                    <p className="text-gray-700"><span className="font-semibold text-yellow-800">备注:</span> {t.remark}</p>
                  </div>
                )}
                
                {t.contact && (
                  <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-5 py-3 rounded-lg">
                    <span className="font-semibold">联系方式:</span>
                    <span className="ml-2 font-bold">{t.contact}</span>
                  </div>
                )}
              </div>
            </div>
          ))}
          
          {transfers.length === 0 && (
            <div className="col-span-full text-center py-20 bg-white rounded-xl shadow-md border border-gray-100">
              <p className="text-gray-500 text-lg font-medium">暂无对调信息</p>
              <p className="text-gray-400 mt-2">快来发布第一条对调信息吧！</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default Home;
